module.exports = __webpack_public_path__ + "img/Keyboard-Arrow-Left-Filled.7db1704c.svg";